var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1663 20.6673L18.333 18.834M10.5413 19.7507C11.6849 19.7507 12.8173 19.5254 13.8739 19.0878C14.9304 18.6501 15.8904 18.0087 16.6991 17.2C17.5077 16.3914 18.1492 15.4314 18.5868 14.3749C19.0244 13.3183 19.2497 12.1859 19.2497 11.0423C19.2497 9.89872 19.0244 8.76633 18.5868 7.70978C18.1492 6.65324 17.5077 5.69324 16.6991 4.8846C15.8904 4.07595 14.9304 3.4345 13.8739 2.99687C12.8173 2.55923 11.6849 2.33398 10.5413 2.33398C8.23175 2.33398 6.01675 3.25147 4.38362 4.8846C2.75049 6.51773 1.83301 8.73272 1.83301 11.0423C1.83301 13.3519 2.75049 15.5669 4.38362 17.2C6.01675 18.8332 8.23175 19.7507 10.5413 19.7507V19.7507Z",
    stroke: "#292D31",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.86549db5d7492ea87797a8e3651641ff.svg";
export { ForwardRef as ReactComponent };